import { Box, Button, Container, Typography, styled } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router'

import flagIcon from '../../../../../assets/vector/flagHC.svg'
import qaIcon from '../../../../../assets/vector/qaHC.svg'
import videoIcon from '../../../../../assets/vector/videoHC.svg'
import { IRootState } from '../../../../../redux/types'
import {
  CardIconWrapper,
  CardItem,
  CardTextContent,
  ContactButton,
  FocusCardContent,
  OptionButton
} from '../../../../shared/styles/HelpCenterStyles'
import Hero from '../components/Hero'

const CardsContainer = styled(Box)(() => ({
  marginTop: '-153px',
  display: 'flex',
  justifyContent: 'center',
  flexWrap: 'wrap',
  gap: 64
}))

const Home = () => {
  const { t } = useTranslation(['helpcenter'])
  const navigate = useNavigate()
  const { user: authUser } = useSelector((state: IRootState) => state.auth)

  const handleSection = (section: string) => {
    navigate(`/ayuda/tutoriales/client/${section}/0`)
  }

  const handleContact = () => {
    navigate('/ayuda/contacto')
  }

  return (
    <Container sx={{ padding: 0 }} maxWidth="xl">
      <Hero />
      <CardsContainer id="home-cards-helpcenter">
        <CardItem id="help-card-helpcenter">
          <FocusCardContent
            onClick={() => {
              navigate('/ayuda/comoempezar')
            }}
          >
            <CardIconWrapper image={flagIcon} title={t('how-start')} />
            <CardTextContent>
              <Typography variant="h5">{t('how-start')}</Typography>
              <Typography>{t('card1')}</Typography>
            </CardTextContent>
          </FocusCardContent>
        </CardItem>

        <CardItem id="help-card-helpcenter">
          <FocusCardContent onClick={() => navigate('/ayuda/tutoriales/client')}>
            <CardIconWrapper image={videoIcon} title={t('card2t')} />
            <CardTextContent>
              <Typography variant="h5">{t('card2t')}</Typography>
              <Typography>{t('card2')}</Typography>
            </CardTextContent>
          </FocusCardContent>
        </CardItem>

        {[1, 2, 3, 4, 5, 8, 9].includes(authUser?.role_id) && (
          <CardItem id="help-card-helpcenter">
            <FocusCardContent onClick={() => navigate('/ayuda/tutoriales/admin')}>
              <CardIconWrapper image={qaIcon} title={t('card3t')} />
              <CardTextContent>
                <Typography variant="h5">{t('card3t')}</Typography>
                <Typography>{t('card3')}</Typography>
              </CardTextContent>
            </FocusCardContent>
          </CardItem>
        )}
      </CardsContainer>
      <Container sx={{ maxWidth: '1020px' }}>
        <Box pt={9} sx={{ display: 'flex', justifyContent: 'center', gap: '48px', flexWrap: 'wrap' }} id="home-options-helpcenter">
          <OptionButton variant="outlined" color="primary" onClick={() => handleSection('about-plei')}>
            Acerca de {import.meta.env.VITE_NAME}
          </OptionButton>
          <OptionButton variant="outlined" color="primary" onClick={() => handleSection('profile')}>
            Mi perfil
          </OptionButton>
          <OptionButton variant="outlined" color="primary" onClick={() => handleSection('library')}>
            Biblioteca
          </OptionButton>
          <OptionButton variant="outlined" color="primary" onClick={() => handleSection('academy')}>
            Formación
          </OptionButton>
          <OptionButton variant="outlined" color="primary" onClick={() => handleSection('events')}>
            Eventos
          </OptionButton>
        </Box>
        <Box pt={15} sx={{ textAlign: 'center', display: 'flex', flexDirection: 'column', gap: '8px', alignItems: 'center' }}>
          <Typography variant="h5">{t('morehelp')}</Typography>
          <Typography color="text.secondary">{t('team')}</Typography>
          <ContactButton variant="contained" color="primary" onClick={handleContact}>
            {t('contactus')}
          </ContactButton>
        </Box>
      </Container>
    </Container>
  )
}

export default Home
